module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAAAzklEQVQ4ja1SWw3DMAy0pgEIhEIohEAohEIohEEIhEEohI1BIRRCGHjydNGuiRv1Y5aspvb5/BRV9fShqll/kmFrsF7wE2H2jVC2dQlGABeHeIFv7BFYmftJWwLfoZWbtLI7tiKNzyMYOgSt798zME2dLaQra+RsLF5VDUFAtuwQZPjCGUEEqFzdTMEzXWcG9kBQhrdRhkQEiSrceJjFaAfCwaYvIrA3t2lYiwk8sKGaRy3sM+x33XcRmUTkjSPpHVGs/i1mMrbVyXZNVNcPnEHDK8hreecAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/img/用户.png
// module id = +yV1
// module chunks = 1